module.exports = __webpack_public_path__ + "img/1552953634.dc0d05e2.jpg";